export default __webpack_public_path__ + "error.hbs";